import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import actions
import { updateMaterialsFilter } from 'js/store/search/Search.actions';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getAvailableOptionsById } from 'js/store/search/Search.selectors';

// import components
import ButtonToggle from 'js/components/button/Button.toggle';

const FindMaterialsOptions = () => {
  const dispatch = useDispatch();

  const availableMaterials = useSelector((state) => getAvailableOptionsById(state, 'avoidMaterials'));

  const toggleLabels = {
    false: useSelector((state) => getTranslationById(state, 'find_step_2_toggle_false', 'No')),
    true: useSelector((state) => getTranslationById(state, 'find_step_2_toggle_true', 'Yes')),
  };

  const selectedMaterials = useSelector((state) => state?.search?.filters?.avoidMaterials || false);
  const title = useSelector((state) =>
    getTranslationById(state, 'find_step_2_avoid_materials_title', 'What materials?')
  );

  const updateSelection = (value) => {
    dispatch(updateMaterialsFilter(value));
  };

  return (
    <div className="find__materials">
      <h2 className="find__title find__materials-title">{title}</h2>
      <ButtonToggle
        labels={toggleLabels}
        selected={selectedMaterials}
        onToggle={updateSelection}
        disabled={!availableMaterials}
      />
    </div>
  );
};

export default FindMaterialsOptions;
